<template>
  <div class="image-circle plus">
    <span v-if="index == 3 && total > 4">+{{ total - 3 }}</span>
    <img v-else-if="user.profileimg === 'default'" src="https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f" class="image-circle">
    <img v-else :src="user.profileimg" class="image-circle">
  </div>
</template>

<script>
import { db } from '@/firebase'

export default {
  name: 'ProfilePicture',
  props: ['member', 'index', 'total'],
  firebase () {
    return {
      user: {
        source: db.ref('users/' + this.member),
        asObject: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProfilePicture.vue?6e463f4c